import { TravelOption } from 'components/search/expedia/enums';
import { TravelOptionsState } from 'components/search/expedia/interfaces';

const initialTravelOptionsState: TravelOptionsState = {
  travelOptions: [TravelOption.HOTELS, TravelOption.FLIGHTS_HOTELS, TravelOption.FLIGHTS],
};

export { initialTravelOptionsState };
